<template>
  <div class="sc-full-screen sc-flex-center">
    <div class="sc-splash-container">
      <img class="sc-splash-logo" src="./images/logo-big.png" width="260" height="85" alt="Loading..." />
      <div class="sc-splash-content">
        <span if.bind="!navigating && !error" class="sc-element-blink">Awaiting instructions...</span>
        <span if.bind="!navigating && error"><span class="text-danger">Application failed</span> • <a href="javascript:location.reload()">Reload</a></span>
        <span if.bind="navigating" class="sc-element-blink">Loading home screen...</span>
      </div>
    </div>
  </div>
</template>
